var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};
/* eslint-disable no-return-assign */


import { METHOD } from "./GenericRequest";
import { CancellableGenericRequest } from "./CancellableGenericRequest";
var WSUUID = 0;
/**
 * Generic request that automatically dispatches a redux action on every state of the request.
 *
 * <p>
 * @inheritDoc
 * </p>
 * @abstract
 *
 */

var ReduxAwareGenericRequest =
/** @class */
function (_super) {
  __extends(ReduxAwareGenericRequest, _super);
  /**
   * @inheritDoc
   */


  function ReduxAwareGenericRequest(method, url, generalErrorMessage, reduxDispatcherFunction) {
    if (method === void 0) {
      method = METHOD.METHOD_POST;
    }

    var _this = _super.call(this, method, url, generalErrorMessage) || this;

    _this.reduxDispatcherFunction = reduxDispatcherFunction;

    var emptyFunc = function emptyFunc() {
      return null;
    };

    _this.dispatchReduxOnPostExecutionEvent = _this.dispatchReduxOnPostExecutionEvent.bind(_this);
    _this.dispatchReduxOnPreExecutionEvent = _this.dispatchReduxOnPreExecutionEvent.bind(_this);
    _this.dispatchReduxOnSuccessEvent = _this.dispatchReduxOnSuccessEvent.bind(_this);
    _this.dispatchReduxOnFailEvent = _this.dispatchReduxOnFailEvent.bind(_this);

    _this.onPostExecution(emptyFunc);

    _this.onPreExecution(emptyFunc);

    _this.onSuccess(emptyFunc);

    _this.onFail(emptyFunc);

    return _this;
  }
  /**
   * Gets the class unique identifier. If the identifier does not exist then a new one is generated.
   *
   * @return {number} The identifier.
   */


  ReduxAwareGenericRequest.getUuid = function () {
    return this.iUUID === undefined ? this.iUUID = WSUUID++ : this.iUUID;
  };

  Object.defineProperty(ReduxAwareGenericRequest, "REDUX_ACTION_OBJECT_ON_POST_EXECUTE", {
    //////////////////////////
    //
    // Redux Objects
    //
    //
    //
    //

    /**
     * Redux object template for the postExecution callback.
     *
     * @return {{type: string, payload: undefined}} The redux object.
     */
    get: function get() {
      return {
        type: this.ACTIONS_STRINGS.ON_POST_EXECUTE,
        payload: undefined
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReduxAwareGenericRequest, "REDUX_ACTION_OBJECT_ON_PRE_EXECUTE", {
    /**
     * Redux object template for the preExecution callback.
     *
     * @return {{type: string, payload: undefined}} The redux object.
     */
    get: function get() {
      return {
        type: this.ACTIONS_STRINGS.ON_PRE_EXECUTE,
        payload: undefined
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReduxAwareGenericRequest, "REDUX_ACTION_OBJECT_ON_SUCCESS", {
    /**
     * Redux object template for the onSuccess callback.
     *
     * @return {{type: string, payload: ResponseType}} The redux object.
     */
    // @ts-ignore
    get: function get() {
      return {
        type: this.ACTIONS_STRINGS.ON_SUCCESS,
        payload: undefined
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReduxAwareGenericRequest, "REDUX_ACTION_OBJECT_ON_FAIL", {
    /**
     * Redux object template for the onFail callback.
     *
     * @return {{type: string, payload: string}} The redux object.
     */
    get: function get() {
      return {
        type: this.ACTIONS_STRINGS.ON_FAIL,
        payload: undefined
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReduxAwareGenericRequest, "ACTIONS_STRINGS", {
    //////////////////////////
    //
    // Redux Identifiers
    //
    //
    //
    //

    /**
     * Getter that creates the redux class identifiers.
     *
     * @return {{ON_POST_EXECUTE: string, ON_PRE_EXECUTE: string, ON_SUCCESS: string, ON_FAIL: string}} Class redux identifiers
     */
    get: function get() {
      return {
        ON_POST_EXECUTE: this.getUuid() + "_" + this.name.toUpperCase() + "_ON_POST_EXECUTE",
        ON_PRE_EXECUTE: this.getUuid() + "_" + this.name.toUpperCase() + "_ON_PRE_EXECUTE",
        ON_SUCCESS: this.getUuid() + "_" + this.name.toUpperCase() + "_ON_SUCCESS",
        ON_FAIL: this.getUuid() + "_" + this.name.toUpperCase() + "_ON_FAIL"
      };
    },
    enumerable: true,
    configurable: true
  }); //////////////////////////
  //
  // Redux Callbacks
  //
  //
  //
  //

  /**
   * First callback that is going to be called in onPostExecution callbacks. Dispatches the onPostExecution redux action.
   */

  ReduxAwareGenericRequest.prototype.dispatchReduxOnPostExecutionEvent = function () {
    this.reduxDispatcherFunction(this.constructor.REDUX_ACTION_OBJECT_ON_POST_EXECUTE);
  };
  /**
   * First callback that is going to be called in onPreExecution callbacks. Dispatches the onPreExecution redux action.
   */


  ReduxAwareGenericRequest.prototype.dispatchReduxOnPreExecutionEvent = function () {
    this.reduxDispatcherFunction(this.constructor.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE);
  };
  /**
   * First callback that is going to be called in onSuccess callbacks. Dispatches the onSuccess redux action.
   */


  ReduxAwareGenericRequest.prototype.dispatchReduxOnSuccessEvent = function (successObject) {
    this.reduxDispatcherFunction(__assign({}, this.constructor.REDUX_ACTION_OBJECT_ON_SUCCESS, {
      payload: successObject
    }));
  };
  /**
   * First callback that is going to be called in onFail callbacks. Dispatches the onFail redux action.
   */


  ReduxAwareGenericRequest.prototype.dispatchReduxOnFailEvent = function (why) {
    this.reduxDispatcherFunction(__assign({}, this.constructor.REDUX_ACTION_OBJECT_ON_FAIL, {
      payload: why
    }));
  }; //////////////////////////
  //
  // Request Callbacks
  //
  //
  //
  //

  /**
   * @inheritDoc
   */


  ReduxAwareGenericRequest.prototype.onPreExecution = function () {
    var onPreExecutionFunctions = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      onPreExecutionFunctions[_i] = arguments[_i];
    }

    return _super.prototype.onPreExecution.apply(this, [this.dispatchReduxOnPreExecutionEvent].concat(onPreExecutionFunctions));
  };
  /**
   * @inheritDoc
   */


  ReduxAwareGenericRequest.prototype.onPostExecution = function () {
    var onPostExecutionFunctions = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      onPostExecutionFunctions[_i] = arguments[_i];
    }

    return _super.prototype.onPostExecution.apply(this, [this.dispatchReduxOnPostExecutionEvent].concat(onPostExecutionFunctions));
  };
  /**
   * @inheritDoc
   */


  ReduxAwareGenericRequest.prototype.onSuccess = function () {
    var successFunctions = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      successFunctions[_i] = arguments[_i];
    }

    return _super.prototype.onSuccess.apply(this, [this.dispatchReduxOnSuccessEvent].concat(successFunctions));
  };
  /**
   * @inheritDoc
   */


  ReduxAwareGenericRequest.prototype.onFail = function () {
    var failFunctions = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      failFunctions[_i] = arguments[_i];
    }

    return _super.prototype.onFail.apply(this, [this.dispatchReduxOnFailEvent].concat(failFunctions));
  };

  return ReduxAwareGenericRequest;
}(CancellableGenericRequest);

export { ReduxAwareGenericRequest };